<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <!-- Case: no group -->
  <BFormRadioWrapper
    v-if="!group"
    :class="{
      [computedClass]: computedClass
    }"
    :is-custom="isCustom"
    :plain="plain"
    :inline="inline"
  >
    <input
      v-bind="computedAttrs"
      v-model="localValue"
      @blur="handleFocus"
      @focus="handleFocus"
    >
    <label
      :for="_id"
    >
      <slot />
    </label>
  </BFormRadioWrapper>
  <!-- Case: group + button -->
  <template v-else-if="button">
    <input
      v-bind="computedAttrs"
      v-model="localValue"
      class="btn-check"
      @blur="handleFocus"
      @focus="handleFocus"
    >
    <label
      :for="_id"
      :class="[button && buttonClasses ? buttonClasses : 'custom-control custom-control-inline custom-radio']"
    >
      <slot />
    </label>
  </template>

  <!-- Case: group, not button -->
  <div
    v-else
    :class="{
      'form-check': true,
    }"
  >
    <input
      v-bind="computedAttrs"
      v-model="localValue"
      @blur="handleFocus"
      @focus="handleFocus"
    >
    <label
      :class="{
        'form-check-label': true,
      }"
      :for="_id"
    >
      <slot />
    </label>
  </div>
</template>

<script>
import BFormRadioWrapper from './BFormRadioWrapper.vue'
export default {
  name: 'BFormRadio',
  components: {
    BFormRadioWrapper
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: undefined
    },
    value: {
      type: [String, Number, Boolean],
      default: undefined
    },
    name: {
      type: String,
      default: null
    },
    checked: Boolean,
    disabled: Boolean,
    button: Boolean,
    inline: Boolean,
    stacked: Boolean,
    plain: Boolean,
    buttonVariant: {
      type: String,
      default: 'secondary'
    },
    group: Boolean,
    size: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      hasFocus: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    },
    computedClass() {
      return this.$attrs.class
    },
    isGroup() {
      return this.group
    },
    isBtnMode() {
      return this.button
    },
    isPlain() {
      return this.isBtnMode ? false : this.plain
    },
    isCustom() {
      return this.isBtnMode ? false : !this.isPlain
    },
    isInline() {
      return this.group ? !this.stacked : this.inline
    },
    buttonClasses() {
      return [
        'btn',
        `btn-${this.buttonVariant}`,
        {
          [`btn-${this.size}`]: this.size,
          disabled: this.disabled,
          active: this.isChecked,
          focus: this.hasFocus
        }
      ]
    },
    computedAttrs() {
      const attrs = { ...this.$attrs }
      attrs.class = null
      attrs.checked = this.isChecked
      attrs.disabled = this.disabled
      attrs.type = 'radio'
      attrs.name = this.name
      attrs.value = this.value
      attrs.id = this._id
      attrs.class = [
        {
          'form-check-input': true
        }
      ]
      return attrs
    },
    isChecked() {
      return this.modelValue === this.value
    }
  },
  created() {
    this._id = `_BV_radio_${this.$uuid}`
  },
  methods: {
    handleFocus(e) {
      if (!this.button) return
      // When in buttons mode, we need to add 'focus' class to label when input focused
      // As it is the hidden input which has actual focus
      if (e.target) {
        if (e.type === 'focus') {
          this.hasFocus = true
        } else if (e.type === 'blur') {
          this.hasFocus = false
        }
      }
    },
    focus() {
      this.$el.focus()
    },
    blur() {
      this.$el.blur()
    }
  }
}
</script>
